document.addEventListener('DOMContentLoaded', function() {
  // Attendre que tous les éléments soient chargés
  setTimeout(function() {
    // Garder les fonctionnalités de survol mais bloquer les clics
    document.querySelectorAll('.shoppable-image__hotspot').forEach(function(hotspot) {
      // S'assurer que les hotspots sont visibles
      hotspot.style.visibility = 'visible';
      
      // Empêcher la navigation au clic
      hotspot.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      });
      
      // Cibler les tooltips à l'intérieur des hotspots
      let tooltips = hotspot.querySelectorAll('.hotspot__tooltip-wrapper a');
      tooltips.forEach(function(tooltip) {
        // Empêcher la navigation au clic sur les tooltips
        tooltip.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        });
      });
    });
  }, 1000); // Délai d'une seconde pour s'assurer que tous les éléments sont chargés
});